import localForage from 'localforage'
import { INSTANCE as UserInfoManager } from '../userInfo/UserInfoManager'
import type { NoticeDataType } from './NotificationManager'

export class NoticeStore {
  #store: LocalForage | undefined
  constructor() {
    this.#initDB()
  }

  async #initDB() {
    let userInfo = undefined

    try {
      userInfo = await UserInfoManager.getUserInfo()
    } catch (error) {
      return
    }

    if (!userInfo) return

    const name = 'noticeDB'
    const storeName = `notice_id-${userInfo.sessionId}`

    localForage.config({
      driver: localForage.WEBSQL,
      name,
      version: 1.0,
      storeName,
    })

    this.#store = localForage.createInstance({
      name,
      storeName,
    })
  }

  cacheNotices(noticeIds: string[]) {
    if (!this.#store) return

    for (const id of noticeIds) {
      this.#store.setItem(id, id)
    }
  }

  async resetByList(allActionNoticeData: NoticeDataType[]) {
    if (!this.#store) return

    const catchIds = (await this.#store.keys()) || []

    for (let index = 0; index < catchIds.length; index++) {
      const id = catchIds[index]
      const notice = allActionNoticeData.find((notice) => id === notice.id)

      if (!notice) {
        this.#store.removeItem(id)
      }
    }
  }

  async removeCacheNoticeByKey(id: string) {
    if (!this.#store) return

    const cacheNoticeId = await this.#store.getItem(id)

    cacheNoticeId && this.#store.removeItem(id)
  }

  async getNoticeById(id: string) {
    if (!this.#store) return undefined

    const cacheNoticeId = await this.#store.getItem(id)

    return cacheNoticeId
  }
}
